import { ApiResult } from 'src/Libs/api'
import { AuthFetchWithResponse } from 'src/Types/api'
import { CloudKeyPayload, InstallationExtensionsDto, InstallationExtensionsModel } from '../models/installation-extensions.model'
import { StatusCodes } from '@e3dc-react/shell/Libs'
import { handleFetchError } from 'src/Libs/api/utils'
import fromDtoToModelTransformer from '../transformers/from-dto-to-model.transformer'
import { FetchProps } from '@e3dc-react/shell/Hooks/AuthFetch/AuthFetch'
import { ExtensionsType } from 'src/Libs/api/types'
import { AxiosResponse } from 'axios'

/**
 * Get the state of installation extensions
 *
 * @param installationId Storage serial number
 * @param authFetch
 * @throws UnexpectedApiResponseError if an unhandled api error appears
 */
export const getInstallationExtensionsStates = async (
  installationId: number,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<InstallationExtensionsModel[]>> => {
  try {
    const response = await authFetch<InstallationExtensionsDto[]>({
      path: `installations/${installationId}/extensions`,
      method: 'GET',
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    })

    if (response.status === StatusCodes.OK) {
      const model = fromDtoToModelTransformer(response.data)
      return new ApiResult<InstallationExtensionsModel[]>(model)
    }

    if (response.status === StatusCodes.NO_CONTENT) return new ApiResult<InstallationExtensionsModel[]>([], false)
    return new ApiResult<InstallationExtensionsModel[]>(null, true)
  } catch (error) {
    return handleFetchError<InstallationExtensionsModel[]>(error)
  }
}

/**
 * Creates a new Luox Energy cloud key if no key exists. If key already exists that one is returned
 *
 * @param installationId
 * @param authFetch
 */
export const createLuoxEnergyCloudKey = async (installationId: number, authFetch: AuthFetchWithResponse): Promise<ApiResult<string>> => {
  const payload: CloudKeyPayload = {
    description: 'Luox Energy',
    scope: ExtensionsType.luoxEnergy,
  }

  const fetchProps = {
    path: `installations/${installationId}/cloud-keys`,
    endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    method: 'post',
    payload: payload,
  } as FetchProps

  const response: AxiosResponse<string, unknown> = await authFetch(fetchProps)

  if (response.status === StatusCodes.CREATED || response.status === StatusCodes.OK) {
    return new ApiResult(response.data, false)
  }

  return new ApiResult<string>(null, true)
}
